<template>

    <section  :class="`grid c_${item.component.id}__inner_container c_${item.component.id}__inner_container_${theme_id ?? ''}`">
      <div  :class="`c_${item.component.id}__heading_container c_${item.component.id}__heading_container_${theme_id ?? ''}`">
        <div :class="`grid c_${ item.component.subcomponents.heading.id }__outer_container c_${ item.component.subcomponents.heading.id }__outer_container_${ theme_id ?? '' }`">
          <div :class="`grid c_${ item.component.subcomponents.heading.id }__inner_container c_${ item.component.subcomponents.heading.id }__inner_container_${ theme_id ?? '' }`">
            <h3 :class="`grid c_${ item.component.subcomponents.heading.id }__heading c_${ item.component.subcomponents.heading.id }__heading_${ theme_id ?? '' }`">
              {{ item.settings.heading.text }}          
            </h3>
          </div>
        </div>
        <div :class="`grid c_${item.component.subcomponents.button.id}__outer_container c_${item.component.subcomponents.button.id}__outer_container_${theme_id ?? ''}`">
          <review-form :product="product" :auth="auth" :cta="item.settings.call_to_action.text" :button_component="item.component.subcomponents.button" :theme_id="theme_id"></review-form>
        </div>
      </div>
      <div v-if="average">
        <table class="table-auto border-collapse w-full rounded max-w-sm">
          <tr>
            <th class="w-8 text-gray-900 text-left font-bold">Overall</th>
            <td class="w-auto px-4">
              <div
                class="stars stars-sm"
                :style="`--rating: ${average}`"
                :aria-label="`Rating of this product is ${average} out of 5.`"
              ></div>
            </td>
            <td class="w-8 text-gray-900 text-left"></td>
          </tr>
          <tr
            @click="setRatingFilter('5★')"
            :class="{ 'cursor-pointer hover:bg-gray-50': total_5_star }"
          >
            <th class="w-8 text-gray-900 text-left font-bold">5★</th>
            <td class="w-auto">
              <div class="grid items-center px-4">
                <progress :value="average_5_star" max="100">
                  {{ average_5_star }}%
                </progress>
              </div>
            </td>
            <td class="w-8 text-gray-900 text-right">{{ total_5_star }}</td>
          </tr>
          <tr
            @click="setRatingFilter('4★')"
            :class="{ 'cursor-pointer hover:bg-gray-50': total_4_star }"
          >
            <th class="w-8 text-gray-900 text-left font-bold">4★</th>
            <td class="w-auto">
              <div class="grid items-center px-4">
                <progress :value="average_4_star" max="100">
                  {{ average_4_star }}%
                </progress>
              </div>
            </td>
            <td class="w-8 text-gray-900 text-right">{{ total_4_star }}</td>
          </tr>
          <tr
            @click="setRatingFilter('3★')"
            :class="{ 'cursor-pointer hover:bg-gray-50': total_3_star }"
          >
            <th class="w-8 text-gray-900 text-left font-bold">3★</th>
            <td class="w-auto">
              <div class="grid items-center px-4">
                <progress :value="average_3_star" max="100">
                  {{ average_3_star }}%
                </progress>
              </div>
            </td>
            <td class="w-8 text-gray-900 text-right">
              {{ total_3_star }}
            </td>
          </tr>
          <tr
            @click="setRatingFilter('2★')"
            :class="{ 'cursor-pointer hover:bg-gray-50': total_2_star }"
          >
            <th class="w-8 text-gray-900 text-left font-bold">2★</th>
            <td class="w-auto">
              <div class="grid items-center px-4">
                <progress :value="average_2_star" max="100">
                  {{ average_2_star }}%
                </progress>
              </div>
            </td>
            <td class="w-8 text-gray-900 text-right">{{ total_2_star }}</td>
          </tr>
          <tr
            @click="setRatingFilter('1★')"
            :class="{ 'cursor-pointer hover:bg-gray-50': total_1_star }"
          >
            <th class="w-8 text-gray-900 text-left font-bold">1★</th>
            <td>
              <div class="grid items-center px-4">
                <progress
                  class="bg-primary-500"
                  :value="average_1_star"
                  max="100"
                >
                  {{ average_1_star }}%
                </progress>
              </div>
            </td>
            <td class="w-8 text-gray-900 text-right">{{ total_1_star }}</td>
          </tr>
        </table>
      </div>

      <div :class="`grid c_${item.component.id}__options_container c_${item.component.id}__options_container_${theme_id ?? ''}`">
        <div :class="`grid c_${item.component.id}__filter_select c_${item.component.id}__filter_select_${theme_id ?? ''}`">
          <div :class="`grid c_${item.component.subcomponents.form_input.id}__outer_container c_${item.component.subcomponents.form_input.id}__outer_container_${theme_id ?? ''}`">
            <label for="filter_by" 
            :class="`c_${item.component.subcomponents.form_input.id}__label c_${item.component.subcomponents.form_input.id}__label_${theme_id ?? ''}`">Filter</label>
            <select
              name="filter_by"
              id="filter_by"
              :class="`c_${item.component.subcomponents.form_input.id}__input c_${item.component.subcomponents.form_input.id}__input_${theme_id ?? ''}`"
              v-model="filter_option"
            >
              <option
                :value="filter_option"
                v-for="filter_option in filter_options"
                :key="filter_option"
              >
                {{ filter_option }}
              </option>
            </select>
          </div>
        </div>
        <div :class="`grid c_${item.component.id}__sort_select c_${item.component.id}__sort_select_${theme_id ?? ''}`">
          <div :class="`grid c_${item.component.subcomponents.form_input.id}__outer_container c_${item.component.subcomponents.form_input.id}__outer_container_${theme_id ?? ''}`">
            <label for="sort_by" 
            :class="`c_${item.component.subcomponents.form_input.id}__label c_${item.component.subcomponents.form_input.id}__label_${theme_id ?? ''}`">Sort</label>
            <select
              name="sort_by"
              id="sort_by"
              :class="` c_${item.component.subcomponents.form_input.id}__input c_${item.component.subcomponents.form_input.id}__input_${theme_id ?? ''}`"
              v-model="sort_option"
            >
              <option
                :value="sort_option"
                v-for="sort_option in sort_options"
                :key="sort_option"
              >
                {{ sort_option }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div :class="`grid c_${item.component.id}__review_cards_container c_${item.component.id}__review_cards_container_${theme_id ?? ''}`">
        <template v-if="!show_spinner && reviews.length">
          <div
          class="grid containable"
           v-for="review in reviews"
            :key="review.id">
            <article
              
              :class="`grid c_${item.component.subcomponents.product_review_card.id}__card c_${item.component.subcomponents.product_review_card.id}__card_${theme_id ?? ''}`"
            >
              <div
                class="stars stars-sm"
                :style="`--rating: ${review.rating}`"
                :aria-label="`Rating of this product is ${review.rating} out of 5.`"
              ></div>
              <p  :class="`grid c_${item.component.subcomponents.product_review_card.id}__reference c_${item.component.subcomponents.product_review_card.id}__reference_${theme_id ?? ''}`">
                {{ review.name }} - {{ getRelativeTime(review.created_at) }}
              </p>
              <h4 :class="`grid c_${item.component.subcomponents.product_review_card.id}__title c_${item.component.subcomponents.product_review_card.id}__title_${theme_id ?? ''}`">{{ review.title }}</h4>
              <p  :class="`grid c_${item.component.subcomponents.product_review_card.id}__comment c_${item.component.subcomponents.product_review_card.id}__comment_${theme_id ?? ''}`">{{ review.comment }}</p>
              <div v-if="review.reply"  :class="`grid c_${item.component.subcomponents.product_review_card.id}__reply_container c_${item.component.subcomponents.product_review_card.id}__reply_container_${theme_id ?? ''}`">
                <p  :class="`grid c_${item.component.subcomponents.product_review_card.id}__reply_time c_${item.component.subcomponents.product_review_card.id}__reply_time_${theme_id ?? ''}`">
                  REPLY - {{ getRelativeTime(review.reply.created_at) }}
                </p>
                <p  :class="`grid c_${item.component.subcomponents.product_review_card.id}__reply_comment c_${item.component.subcomponents.product_review_card.id}__reply_comment_${theme_id ?? ''}`">{{ review.reply.comment }}</p>
              </div>
            </article>
          </div>
        </template>
        <div
          class="p-4 text-center"
          v-else-if="!reviews.length && !show_spinner"
        >
          Sorry, there are no reviews to show
        </div>
        <div v-else class="grid place-items-center p-4">
          <spinner-icon class="form-spinner"></spinner-icon>
        </div>
      </div>

        <div
        :class="`grid c_${item.component.id}__pagination_container c_${item.component.id}__pagination_container_${theme_id ?? ''}`"
        >
          <div  :class="`grid c_${item.component.id}__pagination_numbers c_${item.component.id}__pagination_numbers_${theme_id ?? ''}`">
            {{ pagination.from ?? 0 }} to {{ pagination.to ?? 0 }} of
            {{ pagination.total }} Reviews
          </div>
          <div :class="`flex c_${item.component.id}__pagination_buttons c_${item.component.id}__pagination_buttons_${theme_id ?? ''}`">
            <div  :class="`grid c_${item.component.subcomponents.navigation_button.id}__outer_container c_${item.component.subcomponents.navigation_button.id}__outer_container_${theme_id ?? ''}`">
              <button
              type="button" 
              :class="`c_${item.component.subcomponents.navigation_button.id}__button c_${item.component.subcomponents.navigation_button.id}__button_${theme_id ?? ''}`"
                @click="changePage(page - 1)"
                :disabled="!pagination.prev_page_url"
              >
                Previous
              </button>
            </div>
            <div  :class="`grid c_${item.component.subcomponents.navigation_button.id}__outer_container c_${item.component.subcomponents.navigation_button.id}__outer_container_${theme_id ?? ''}`">
            <button
            type="button" 
            :class="`c_${item.component.subcomponents.navigation_button.id}__button c_${item.component.subcomponents.navigation_button.id}__button_${theme_id ?? ''}`"
              @click="changePage(page + 1)"
              :disabled="!pagination.next_page_url"
            >
              Next
            </button>
            </div>
          </div>
        </div>

    </section>
</template>

<script>
import dayjs from "dayjs";
import SpinnerIcon from "./icons/SpinnerIcon.vue";
import ReviewForm from "./ReviewForm.vue";

export default {
  props: {
    product: Object,
    auth: Object,
    item: Object,
    theme_id: String|null,
  },
  components: {
    SpinnerIcon,
    ReviewForm,
  },
  data() {
    return {
      show_spinner: false,
      average: null,
      reviews: [],
      total_5_star: 0,
      total_4_star: 0,
      total_3_star: 0,
      total_2_star: 0,
      total_1_star: 0,
      page: 1,
      pagination: {
        current_page: null,
        first_page_url: null,
        from: null,
        last_page: null,
        last_page_url: null,
        links: [],
        next_page_url: null,
        per_page: null,
        prev_page_url: null,
        to: null,
        total: null,
      },
      sort_option: "Most Recent",
      filter_option: "All",
      sort: "created_at",
      descending: "desc",
      filters: {
        rating: null,
      },
      sort_options: ["Most Recent", "Highest Rating", "lowest Rating"],
      filter_options: ["All", "5★", "4★", "3★", "2★", "1★"],
    };
  },
  computed: {
    total() {
      return (
        this.total_5_star +
        this.total_4_star +
        this.total_3_star +
        this.total_2_star +
        this.total_1_star
      );
    },
    average_5_star() {
      return (this.total_5_star * 100) / this.total;
    },
    average_4_star() {
      return (this.total_4_star * 100) / this.total;
    },
    average_3_star() {
      return (this.total_3_star * 100) / this.total;
    },
    average_2_star() {
      return (this.total_2_star * 100) / this.total;
    },
    average_1_star() {
      return (this.total_1_star * 100) / this.total;
    },
  },
  watch: {
    sort_option(val) {
      switch (val) {
        case "Most Recent":
          this.sort = "created_at";
          this.descending = "desc";
          break;
        case "Highest Rating":
          this.sort = "rating";
          this.descending = "desc";
          break;
        case "Lowest Rating":
          this.sort = "rating";
          this.descending = "asc";
          break;
      }
      this.page = 1;
      this.getReviewData();
    },
    filter_option(val) {
      switch (val) {
        case "All":
          this.filters.rating = null;
          break;
        case "5★":
          this.filters.rating = 5;
          break;
        case "4★":
          this.filters.rating = 4;
          break;
        case "3★":
          this.filters.rating = 3;
          break;
        case "2★":
          this.filters.rating = 2;
          break;
        case "1★":
          this.filters.rating = 1;
          break;
      }
      this.page = 1;
      this.getReviewData();
    },
  },
  methods: {
    getRelativeTime(date) {
      return dayjs().to(dayjs(date));
    },
    setRatingFilter(rating) {
      this.filter_option = rating;
    },
    changePage(new_page) {
      this.page = new_page;
      this.getReviewData();
    },
    getReviewData() {
      if(!this.product?.slug) return
      this.show_spinner = true;
      axios({
        method: "post",
        url: `/shop/products/${this.product.slug}/reviews`,
        data: {
          filters: this.filters,
          sort: this.sort,
          descending: this.descending,
          page: this.page,
        },
      })
        .then(({ data }) => {
          this.reviews = data.reviews.data;
          this.pagination.current_page = data.reviews.current_page;
          this.pagination.first_page_url = data.reviews.first_page_url;
          this.pagination.from = data.reviews.from;
          this.pagination.last_page = data.reviews.last_page;
          this.pagination.last_page_url = data.reviews.last_page_url;
          this.pagination.links = data.reviews.links;
          this.pagination.next_page_url = data.reviews.next_page_url;
          this.pagination.per_page = data.reviews.per_page;
          this.pagination.prev_page_url = data.reviews.prev_page_url;
          this.pagination.to = data.reviews.to;
          this.pagination.total = data.reviews.total;
          this.show_spinner = false;
          this.average = data.average;
          this.total_5_star = parseInt(data.total_5_star);
          this.total_4_star = parseInt(data.total_4_star);
          this.total_3_star = parseInt(data.total_3_star);
          this.total_2_star = parseInt(data.total_2_star);
          this.total_1_star = parseInt(data.total_1_star);
          this.show_spinner = false;
        })
        .catch((error) => {
          this.show_spinner = false;
        });
    },
  },
  mounted() {
    this.getReviewData();
  },
};
</script>
